exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\nvideo[data-v-1e4ee323] {\n\tbackground-color: black;\n\tmax-width: 100%;\n\tmax-height: 100%;\n\talign-self: center;\n\tjustify-self: center;\n\t/* over arrows in tiny screens */\n\tz-index: 20050;\n}\n", ""]);
